export enum ConsentCategory {
  EXPLICIT_OPT_OUT = 'EXPLICIT_OPT_OUT',
  IMPLICIT_CONSENT = 'IMPLICIT_CONSENT',
  EXPLICIT_OPT_IN = 'EXPLICIT_OPT_IN',
}

export interface ConsentConfig {
  category: ConsentCategory;
  defaultChecked: boolean;
  required: boolean;
}

const COUNTRY_CONSENT_MAP: Record<string, ConsentConfig> = {
  US: {
    category: ConsentCategory.IMPLICIT_CONSENT,
    defaultChecked: false,
    required: false,
  },
  IN: {
    category: ConsentCategory.IMPLICIT_CONSENT,
    defaultChecked: false,
    required: false,
  },
  IE: {
    category: ConsentCategory.IMPLICIT_CONSENT,
    defaultChecked: false,
    required: false,
  },
  SG: {
    category: ConsentCategory.IMPLICIT_CONSENT,
    defaultChecked: false,
    required: false,
  },
  BR: {
    category: ConsentCategory.IMPLICIT_CONSENT,
    defaultChecked: false,
    required: false,
  },
  HK: {
    category: ConsentCategory.IMPLICIT_CONSENT,
    defaultChecked: false,
    required: false,
  },
  GB: {
    category: ConsentCategory.EXPLICIT_OPT_OUT,
    defaultChecked: true,
    required: true,
  },
  FR: {
    category: ConsentCategory.EXPLICIT_OPT_OUT,
    defaultChecked: true,
    required: true,
  },
  JP: {
    category: ConsentCategory.EXPLICIT_OPT_OUT,
    defaultChecked: true,
    required: true,
  },
  MY: {
    category: ConsentCategory.EXPLICIT_OPT_OUT,
    defaultChecked: true,
    required: true,
  },
  MX: {
    category: ConsentCategory.EXPLICIT_OPT_OUT,
    defaultChecked: true,
    required: true,
  },
};

const DEFAULT_CONSENT_CONFIG: ConsentConfig = {
  category: ConsentCategory.EXPLICIT_OPT_IN,
  defaultChecked: false,
  required: true,
};

export function getConsentConfigForCountry(
  countryCode?: string,
): ConsentConfig {
  if (!countryCode) {
    return DEFAULT_CONSENT_CONFIG;
  }

  return COUNTRY_CONSENT_MAP[countryCode] || DEFAULT_CONSENT_CONFIG;
}
